import { useMemo, useState } from "react"
import moment from "moment"
import TaskList from "./TaskList"
import "./MyTasksGroupedList.css"

const MY_TASK_GROUPS = [
    { key: "overdue", title: "Overdue", colorClass: "task-group-overdue" },
    { key: "today", title: "Today", colorClass: "task-group-today" },
    { key: "thisWeek", title: "This Week", colorClass: "task-group-thisWeek" },
    { key: "nextWeek", title: "Next Week", colorClass: "task-group-nextWeek" },
    { key: "later", title: "Later", colorClass: "task-group-later" },
    { key: "withoutDate", title: "Without Date", colorClass: "task-group-withoutDate" },
]

function buildGroupDateFilters(groupKey) {
    const today = moment().startOf("day")
    const tomorrow = today.clone().add(1, "day")
    const endOfWeek = today.clone().endOf("isoWeek")
    const startOfNextWeek = today.clone().add(1, "week").startOf("isoWeek")
    const endOfNextWeek = today.clone().add(1, "week").endOf("isoWeek")
    const afterNextWeek = endOfNextWeek.clone().add(1, "day")

    if (groupKey === "withoutDate") {
        return { dueDateIsNull: true }
    }
    if (groupKey === "overdue") {
        return { dueDateIsNull: false, dueDateLte: today.clone().subtract(1, "day").format("YYYY-MM-DD") }
    }
    if (groupKey === "today") {
        const day = today.format("YYYY-MM-DD")
        return { dueDateIsNull: false, dueDateGte: day, dueDateLte: day }
    }
    if (groupKey === "thisWeek") {
        return { dueDateIsNull: false, dueDateGte: tomorrow.format("YYYY-MM-DD"), dueDateLte: endOfWeek.format("YYYY-MM-DD") }
    }
    if (groupKey === "nextWeek") {
        return { dueDateIsNull: false, dueDateGte: startOfNextWeek.format("YYYY-MM-DD"), dueDateLte: endOfNextWeek.format("YYYY-MM-DD") }
    }
    return { dueDateIsNull: false, dueDateGte: afterNextWeek.format("YYYY-MM-DD") }
}

function MyTasksGroupSection({ group, groupIndex, collapsed, onToggle, currentUserId, filterValues, orderBy, updateOrderBy }) {
    return (
        <div key={group.key} className={`${group.colorClass} task-group-section ${groupIndex === 0 ? "task-group-first" : ""}`}>
            <button type="button" className="task-group-toggle" onClick={() => onToggle(group.key)}>
                <i className={`fa ${collapsed ? "fa-chevron-right" : "fa-chevron-down"}`} aria-hidden="true" />
                <span className="task-group-title">{group.title}</span>
            </button>
            {!collapsed && (
                <TaskList
                    assignedToIds={[currentUserId]}
                    {...filterValues}
                    dueDateGte={group.filters.dueDateGte || null}
                    dueDateLte={group.filters.dueDateLte || null}
                    dueDateIsNull={group.filters.dueDateIsNull}
                    orderBy={orderBy}
                    updateOrderBy={updateOrderBy}
                />
            )}
        </div>
    )
}

function MyTasksGroupedList({ currentUserId, filterValues, orderBy, updateOrderBy }) {
    const [collapsedGroups, setCollapsedGroups] = useState({})
    const groups = useMemo(() => MY_TASK_GROUPS.map(group => ({ ...group, filters: buildGroupDateFilters(group.key) })), [])

    const toggleGroup = (groupKey) => {
        setCollapsedGroups((prev) => ({ ...prev, [groupKey]: !prev[groupKey] }))
    }

    return (
        <div className="TaskList my-tasks-grouped-list">
            {groups.map((group, groupIndex) => (
                <MyTasksGroupSection
                    key={group.key}
                    group={group}
                    groupIndex={groupIndex}
                    collapsed={!!collapsedGroups[group.key]}
                    onToggle={toggleGroup}
                    currentUserId={currentUserId}
                    filterValues={filterValues}
                    orderBy={orderBy}
                    updateOrderBy={updateOrderBy}
                />
            ))}
        </div>
    )
}

export default MyTasksGroupedList
